module.exports = __webpack_public_path__ + "img/aia.c2f29c4d.svg";